<template>
  <div>
    <header class="section unlimited-header" :style="{ background : success && (info.bg_color ? info.bg_color : '#f5d784')}">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div
                  class="iframe-wrap"
                  v-html="info.video_url"
                ></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced has-text-white">Unlimited Pass</h1>
            <p class="subtitle has-text-weight-medium has-text-white">
              {{ info.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section price">
      <div class="container">
        <div class="columns is-multiline">
          <div
            class="column is-one-quarter-desktop is-half-tablet is-full-mobile"
            v-for="(item, index) in items"
            :key="index"
          >
            <div
              class="plan-1 has-text-centered has-text-weight-semibold py-4 px-2"
              :style="{ background : item.card_bgcolor ? item.card_bgcolor : bg[index % 4]}"
            >
              <!-- :style="{ background: bg[index % 4] }" -->
              <h3 class="title is-2 has-text-white is-spaced mt-4">
                {{ item.kids }}  {{ item.kids > 1 ? 'Kids' : 'Kid' }}
              </h3>
              <h2 class="title is-2 has-text-white">
                ${{ item.month_price }}<span class="is-size-6"> / mo</span>
              </h2>
              <hr class="mx-1" />
              <h2 class="title is-3 is-size-2-mobile has-text-white">
                ${{ item.year_price }}<span class="is-size-6"> / yr</span>
              </h2>
              <p class="hint has-text-white mb-4">
                ≈ ${{ item.year_per_month }} / mo
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="section notes">
        <div class="columns is-mobile is-vcentered">
          <div class="column is-fullwidth has-text-centered">
            <p class="title is-5 is-hidden-mobile">
              If more than 4 kids, pay
              <span class="underline is-italic has-text-primary"
                >$20 per additional kid</span
              >
              for Monthly Unlimited Pass.
            </p>
            <p class="title is-5 is-hidden-tablet">
              If more than 3 kids, pay
              <span class="underline is-italic has-text-primary"
                >$20 per additional kid</span
              >
              for Monthly Unlimited Pass.
            </p>
            <p class="title is-5">
              Yearly subscription costs
              <span class="underline is-italic has-text-primary"
                >11-month's monthly subscription.</span
              >
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section feature has-background-info-light">
      <div class="container py-4">
        <div class="columns is-multiline">
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/Unlimited-Feature-fun.svg"
              alt="- 1 -"
            />
            <h3 class="title is-spaced is-3">Unlimited Fun</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Once subscribe Unlimited Pass, you unlock the unlimited fun of
                KidsTopia for your kiddos. No more payments for every visit.
                Convenient and great value-for-money!
              </p>
            </div>
          </div>
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/discount.svg"
              alt="- 2 -"
            />
            <h3 class="title is-spaced is-3">Party Discount</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Enjoy 10% OFF your party with your Unlimited Pass! A 3-month minimum membership is required to receive this discount at party checkout. Discount excludes private parties. No other restrictions apply.
              </p>
            </div>
          </div>
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/Unlimited-Feature-socks.svg"
              alt="- 3 -"
            />
            <h3 class="title is-spaced is-3">FREE Grip Sock</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                Your kids will get a pair of grip socks each. No more worries
                about the little payment. Hassle free!
              </p>
            </div>
          </div>
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/Unlimited-Feature-hasslefree.svg"
              alt="- 4 -"
            />
            <h3 class="title is-spaced is-3">Cancel Free</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                If you want to cancel Unlimited Pass, just let us know! We will
                handle the cancellation in 3-5 business days. If you have been
                charged for the next term before finishing the process, we will
                help you with the refund issue. Transparent and easy!
              </p>
            </div>
          </div>
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/Unlimited-Feature-family.svg"
              alt="- 5 -"
            />
            <h3 class="title is-spaced is-3">Family Unit</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                All members must be family and share the same home address. Non-refundable and Non-transferable.
              </p>
            </div>
          </div>
          <div class="column is-4 ng-star-inserted">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/Unlimited-Feature-special.svg"
              alt="- 6 -"
            />
            <h3 class="title is-spaced is-3">Special Case</h3>
            <div
              class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
            >
              <p
                class="subtitle is-6 has-text-weight-medium has-text-justified has-text-grey-darker"
              >
                The Unlimited Pass is subject to private party or other special
                events during which we need to close our store to the public.
                Thank you for your understanding!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section faq">
      <div class="container py-4">
        <h2 class="title has-text-centered mb-6">Frequently Asked Questions</h2>
        <swiper
          class="is-hidden-tablet swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
        >
          <div
            class="swiper-wrapper"
            id="swiper-wrapper-1083e5d482ab674f"
            aria-live="polite"
            style="transition-duration: 0ms"
          >
            <div
              data-swiper-slide-index="0"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        Do I need to pay for admission when I have an Unlimited
                        Pass?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Nope, if you have active Unlimited Pass, you don't need
                        to pay more to enter the playground. Unless that you
                        bring kiddos who are not under the Unlimited Pass.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="1"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        Could I just subscribe Unlimited Pass for one / two
                        months?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Yes, you can. Just let our staff help you with setting a
                        scheduled end date of the Unlimited Pass. Once reach the
                        end date, the subscription will be automatically ended.
                        You will also receive a confirmation email by then.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="2"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        What's the cost of 5 or more kids?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        Say now we want to buy Unlimited Pass for 5 kids, it is
                        $129.99 / month, $1429.89 / year. For monthly
                        subscription, you pay $20 more based on 4 Kids Unlimited
                        Pass. The yearly subscription costs 11-month's monthly
                        subscription.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-swiper-slide-index="3"
              class="swiper-slide ng-star-inserted"
            >
              <div class="card block ng-star-inserted">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                    </div>
                    <div class="media-content">
                      <h3 class="title is-5">
                        Is there any offer for yearly subscription?
                      </h3>
                      <p class="has-text-justified mb-2 has-text-grey-darker">
                        The yearly subscription costs 11-month's monthly
                        subscription. You could save more by subscribing yearly
                        Unlimited Pass.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            class="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span
        ></swiper>
        <div class="columns is-centered is-hidden-mobile">
          <div class="column is-10">
            <mat-accordion class="mat-accordion"
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-0 ng-star-inserted"
                ><mat-expansion-panel-header
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-1 ng-tns-c56-0 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-0"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-0"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-1"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-1"
                      @click="clickMat(0)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        Do I need to pay for admission when I have an Unlimited
                        Pass?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  class="mat-expansion-panel-content ng-tns-c56-0 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-0"
                  aria-labelledby="mat-expansion-panel-header-0"
                  :style="{
                    height: this.matIndex == 0 ? 'auto' : '0px',
                    visibility: this.matIndex == 0 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-0">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-0"
                    >
                      Nope, if you have active Unlimited Pass, you don't need to
                      pay more to enter the playground. Unless that you bring
                      kiddos who are not under the Unlimited Pass.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-2 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-3 ng-tns-c56-2 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-1"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-1"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-3"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-3"
                      @click="clickMat(1)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        Could I just subscribe Unlimited Pass for one / two
                        months?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-2 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-1"
                  aria-labelledby="mat-expansion-panel-header-1"
                  :style="{
                    height: this.matIndex == 1 ? 'auto' : '0px',
                    visibility: this.matIndex == 1 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-2">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-2"
                    >
                      Yes, you can. Just let our staff help you with setting a
                      scheduled end date of the Unlimited Pass. Once reach the
                      end date, the subscription will be automatically ended.
                      You will also receive a confirmation email by then.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-4 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-5 ng-tns-c56-4 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-2"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-2"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-5"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-5"
                      @click="clickMat(2)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        What's the cost of 5 or more kids?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-4 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-2"
                  aria-labelledby="mat-expansion-panel-header-2"
                  :style="{
                    height: this.matIndex == 2 ? 'auto' : '0px',
                    visibility: this.matIndex == 2 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-4">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-4"
                    >
                      Say now we want to buy Unlimited Pass for 5 kids, it is
                      $129.99 / month, $1429.89 / year. For monthly
                      subscription, you pay $20 more based on 4 Kids Unlimited
                      Pass. The yearly subscription costs 11-month's monthly
                      subscription.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ><mat-expansion-panel
                hidetoggle=""
                class="mat-expansion-panel my-1 ng-tns-c56-6 ng-star-inserted"
                ><mat-expansion-panel-header
                  role="button"
                  class="mat-expansion-panel-header mat-focus-indicator ng-tns-c57-7 ng-tns-c56-6 mat-expansion-toggle-indicator-after ng-star-inserted"
                  id="mat-expansion-panel-header-3"
                  tabindex="0"
                  aria-controls="cdk-accordion-child-3"
                  aria-expanded="false"
                  aria-disabled="false"
                  ><span class="mat-content ng-tns-c57-7"
                    ><mat-panel-title
                      class="mat-expansion-panel-header-title ng-tns-c57-7"
                      @click="clickMat(3)"
                      ><img
                        src="@/assets/img/question.svg"
                        alt=""
                        class="image is-24x24 mr-2"
                      />
                      <h3 class="title is-5">
                        Is there any offer for yearly subscription?
                      </h3></mat-panel-title
                    ></span
                  ></mat-expansion-panel-header
                >
                <div
                  role="region"
                  class="mat-expansion-panel-content ng-tns-c56-6 ng-trigger ng-trigger-bodyExpansion"
                  id="cdk-accordion-child-3"
                  aria-labelledby="mat-expansion-panel-header-3"
                  :style="{
                    height: this.matIndex == 3 ? 'auto' : '0px',
                    visibility: this.matIndex == 3 ? '' : 'hidden',
                  }"
                >
                  <div class="mat-expansion-panel-body ng-tns-c56-6">
                    <p
                      class="subtitle is-6 has-text-justified has-text-grey-darker ng-tns-c56-6"
                    >
                      The yearly subscription costs 11-month's monthly
                      subscription. You could save more by subscribing yearly
                      Unlimited Pass.
                    </p>
                  </div>
                </div></mat-expansion-panel
              ></mat-accordion
            >
          </div>
        </div>
        <div class="has-text-centered pt-5 mt-5">
          <h4 class="title is-4">Your questions are not here?</h4>
          <a
            :href="`tel:${config.phone}`"
            class="button is-primary mr-2 has-text-weight-medium"
            >Call Us</a
          ><a
            :href="`mailto:${config.email}`"
            class="button has-text-weight-medium"
            >Email Us</a
          >
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { UnlimitedList } from "@/server/api.js";
import store from "@/store";
export default {
  components: {},
  data() {
    return {
      items: [],
      info: {},
      success: false,
      bg: [
        "linear-gradient(-45deg,#F36C31,#FACA49)",
        "linear-gradient(-45deg,#db4f54,#F28859)",
        "linear-gradient(-45deg,#5c7dce,#6db4ee)",
        "linear-gradient(-45deg,#44AF69,#79d6c5)",
      ],
      matIndex: null,
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await UnlimitedList({});
        if (status == 0) {
          this.items = data.items;
          this.info = data.info;
          this.success = true;
          setTimeout(()=>{
            var iframe = document.getElementsByTagName("iframe")
            for(let i = 0; i <= iframe.length-1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0)
        }
      } catch (error) {}
    },
    clickMat(index) {
      if(this.matIndex == index) {
        this.matIndex = null;
      } else {
        this.matIndex = index;
      }
    },
  },
};
</script>
<style scoped>
article,
aside,
figure,
footer,
header,
hgroup,
section {
  display: block;
}
.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.unlimited-header {
  margin-top: 50px;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}
.columns.is-vcentered {
  align-items: center;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}
.subtitle,
.title {
  word-break: break-word;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.125;
}
.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}
.has-text-white {
  color: #fff !important;
}
.title.is-1 {
  font-size: 3rem;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}

.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.price {
  margin-top: 3rem;
}
.columns.is-multiline {
  flex-wrap: wrap;
}
.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}
.px-2 {
  padding-right: 0.5rem !important;
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.has-text-centered {
  text-align: center !important;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.plan-1,
.plan-2,
.plan-3,
.plan-4 {
  border: none;
  border-radius: 10px;
  box-shadow: 9px 9px 19px #c9c9c9, -9px -9px 19px #fff;
}
.plan-1 {
  background: linear-gradient(-45deg, #f36c31, #faca49);
}
.mt-4 {
  margin-top: 1rem !important;
}
span {
  font-style: inherit;
  font-weight: inherit;
}
.is-size-6 {
  font-size: 1rem !important;
}
.subtitle em,
.subtitle span,
.title em,
.title span {
  font-weight: inherit;
}
code,
hr {
  background-color: #f5f5f5;
}
hr {
  border: none;
  display: block;
  height: 2px;
  margin: 1.5rem 0;
}
.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}
.hint {
  margin-top: -1.5rem;
}
.plan-2 {
  background: linear-gradient(-45deg, #db4f54, #f28859);
}
.plan-3 {
  background: linear-gradient(-45deg, #5c7dce, #6db4ee);
}
.plan-4 {
  background-image: linear-gradient(-45deg, #44af69, #79d6c5);
}
.notes {
  margin-top: 1rem;
}
.title.is-5 {
  font-size: 1.25rem;
}
.has-text-primary {
  color: #de4c50 !important;
}
.is-italic {
  font-style: italic !important;
}
.has-background-info-light {
  background-color: #eef3fc !important;
}
.image.is-48x48 {
  height: 48px;
  width: 48px;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}
.has-text-grey-darker {
  color: #363636 !important;
}
.has-text-justified {
  text-align: justify !important;
}
.subtitle.is-6 {
  font-size: 1rem;
}
.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}
.columns.is-centered {
  justify-content: center;
}

.image.is-24x24 {
  height: 24px;
  width: 24px;
}
.mat-expansion-panel {
  box-sizing: content-box;
  display: block;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  transition: margin 225ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}
.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}
.mat-accordion .mat-expansion-panel:first-of-type {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}

.mat-accordion .mat-expansion-panel:not(.mat-expanded),
.mat-accordion .mat-expansion-panel:not(.mat-expansion-panel-spacing) {
  border-radius: 0;
}
.mat-expansion-panel:not([class*="mat-elevation-z"]) {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.mat-expansion-panel {
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
}
.mat-expansion-panel-header {
  font-family: Roboto, Helvetica Neue, sans-serif;
  font-size: 15px;
  font-weight: 400;
}
.mat-focus-indicator,
.mat-mdc-focus-indicator {
  position: relative;
}

.mat-expansion-panel-header {
  height: 48px;
}

.mat-expansion-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  border-radius: inherit;
  transition: height 225ms cubic-bezier(0.4, 0, 0.2, 1);
}

.mat-content {
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
}
.mat-expansion-panel-header-title {
  color: rgba(0, 0, 0, 0.87);
}
.mat-expansion-panel-header-title,
.mat-expansion-panel-header-description {
  display: flex;
  flex-grow: 1;
  margin-right: 16px;
}
.mat-expansion-panel-header:not([aria-disabled="true"]) {
  cursor: pointer;
}
.pt-5 {
  padding-top: 1.5rem !important;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.title.is-4 {
  font-size: 1.5rem;
}
.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select select,
.textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  position: relative;
  vertical-align: center;
}
.button {
  background-color: #fff;
  border-color: #dbdbdb;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding: calc(0.5em - 1px) 1em;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.media {
  align-items: flex-start;
  display: flex;
  text-align: inherit;
}
.media-left {
  margin-right: 1rem;
}
.title.is-2 {
  font-size: 2.5rem;
}
.mb-6 {
  margin-bottom: 3rem !important;
}
.mat-expansion-panel-content {
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.mat-expansion-panel-body {
  padding: 0 24px 16px;
}
.mat-expansion-panel
  .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled="true"]),
.mat-expansion-panel
  .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled="true"]),
.mat-expansion-panel:not(.mat-expanded)
  .mat-expansion-panel-header:hover:not([aria-disabled="true"]) {
  background: rgba(0, 0, 0, 0.04);
}
.button.is-primary.is-hovered,
.button.is-primary:hover {
  background-color: #dc4145;
  border-color: transparent;
  color: #fff;
}
.button.is-hovered,
.button:hover {
  border-color: #b5b5b5;
  color: #363636;
}
@media (max-width: 768px) {
  .unlimited-header {
    background-image: url(../../assets/img/Kids-Jump.bdf66917305d3a34b885.png);
    background-color: rgba(0, 0, 0, 0.5);
    background-blend-mode: multiply;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  .is-hidden-mobile {
    display: none !important;
  }
}
@media print, screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .column.is-half,
  .column.is-half-tablet {
    flex: none;
    width: 50%;
  }
  .column.is-4,
  .column.is-4-tablet {
    flex: none;
    width: 33.3333333333%;
  }
  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.3333333333%;
  }
}

@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
  .column.is-one-quarter-desktop {
    flex: none;
    width: 25%;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/pricing/unlimited.vue